module.exports = function() {
  return new Worker(__webpack_public_path__ + "1145a837849535fee9c4.worker.js");
};